import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges, OnDestroy} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {RegionService} from '@6grain/masofa-monolith-api-client/dictionaries/api/region.service';

export interface NaturalDisaster {
  name: string;
  count: number;
  area: number;
  percent: number;
}

@Component({
  selector: 'app-disasters-section',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule
  ],
  templateUrl: './disasters-section.component.html',
  styleUrls: ['./disasters-section.component.scss']
})
export class DisastersSectionComponent implements OnChanges, OnDestroy {
  private readonly destroy$ = new Subject<void>();

  private regionService = inject(RegionService);

  @Input() totalArea: string = '';
  @Output() disasterClick = new EventEmitter<NaturalDisaster>();

  allNaturalDisasters: NaturalDisaster[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['totalArea'] && this.totalArea) {
      this.loadAllNaturalDisasters();
    }
  }

  private loadAllNaturalDisasters(): void {
    const date = new Date().toISOString().split('T')[0];
    this.regionService.dictionariesRegionGetRegionsWithFrostDangerDateGet(date).pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (regions) => {
          const frostRegions = regions.filter(r => r.level === 2);
          const count = frostRegions.length;
          const area = frostRegions.reduce((sum, r) => sum + (r.regionSquare ?? 0), 0);
          const total = parseInt(this.totalArea);
          const percent = total > 0 ? (area / total) * 100 : 0;
          this.allNaturalDisasters = [{
            name: 'Frost Danger',
            count,
            area,
            percent
          }];
        },
        error: (err) => console.error(err)
      });
  }

  onDisasterClick(disaster: NaturalDisaster): void {
    this.disasterClick.emit(disaster);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
